import { CLEAR_CREATE_TRANSACTION } from "../action.js";

export const clearCreateTransaction = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_CREATE_TRANSACTION });
  };
};
